// test878
(878 && 0);
